module.exports = __webpack_public_path__ + "img/album01_15.4e09e78e.jpg";